export default String.raw`
{% if settings.blockCompanyDataEdition == 'no' -%}
	{% assign canEditCustomerDetails = true -%}
{% elseif settings.blockCompanyDataEditionFor == 'withLimits' and customer.CreditLimit == null -%}
	{% assign canEditCustomerDetails = true -%}
{% else -%}
	{% assign canEditCustomerDetails = false -%}
{% endif -%}

{% if settings.blockAddingAndEditingDeliveryAddress == 'no' -%}
	{% assign canEditOrAddDeliveryAddress = true -%}
{% elseif settings.blockAddingAndEditingDeliveryAddressFor == 'withLimits' and customer.CreditLimit == null -%}
	{% assign canEditOrAddDeliveryAddress = true -%}
{% else -%}
	{% assign canEditOrAddDeliveryAddress = false -%}
{% endif -%}

<div class="customer-submenu">
	<div class="customer-submenu__header">
		{{translations.MyData}}
	</div>
	{% if canEditCustomerDetails == false or canEditOrAddDeliveryAddress == false -%}
	<div class="message-container">
		{% if canEditCustomerDetails == false and canEditOrAddDeliveryAddress == false -%}
			{{ translations.EditCompanyDataOrAddDeliveryAddressInfo }}
		{% elseif canEditCustomerDetails == false -%}
			{{ translations.EditCompanyDataInfo }}
		{% else -%}
			{{ translations.EditOrAddDeliveryAddressInfo }}
		{% endif -%}
	</div>
	{% endif -%}
	{% if customer.PaymentDueDays != null -%}
	<div class="message-container">{{ translations.PaymentDueDaysInfo | Format:customer.PaymentDueDays }}</div>
	{% endif -%}
	<div class="customer-details-js container-js">
		{% include 'partials/customer-profile/customer-details/customer-data.html' -%}
	</div>
	<div class="customer-submenu__header">
		<h4>{{ translations.DelivAddresses }}</h4>
	{% if canEditOrAddDeliveryAddress -%}
		<div>
			<button class="secondary-action-button set-focus-trap-js replace-template-js opening-modal-mobile-js" data-template="partials/customer-profile/customer-details/add-deli-address.html" data-container=".add-delivery-address-js">
				{{ translations.NewAddress }}
			</button>
			<div class="add-delivery-address-js">
			</div>
		</div>
	{% endif -%}
	</div>
	<div class="delivery-addresses-container-js parent-container-js container-js">
		{% include 'partials/customer-profile/customer-details/deliv-addresses.html' -%}
	</div>
</div>
`